import ResultsTable from './ResultsTable'
import { ResultsTableColumnSelect } from './ResultsTableColumnSelect'
import TableShim from './TableShim'

export * from './ResultsTable'
export * from './ResultsTableColumnSelect'

export default ResultsTable
export { ResultsTableColumnSelect, TableShim }
